<template>
  <div class="simul-games">
    <b-loading :is-full-page="false" v-model="isLoading"></b-loading>

    <div v-if="!isLoading">
      <div class="is-flex is-justify-content-space-between">
        <router-link to="/simuls" class="is-size-4 has-text-link has-text-left">
          &lt;&lt; Simuls
        </router-link>

        <div class="is-flex is-align-items-center">
          <p class="is-size-4 has-text-success-dark">
            {{ simulTitle }}
          </p>
        </div>

        <p class="is-size-4 has-text-right">
          {{ simul.players ? simul.players.length : 0 }}/{{ simul.playerLimit }}
          players
        </p>
      </div>

      <div class="is-flex is-justify-content-space-evenly mt-6">
        <div class="is-flex is-flex-direction-column">
          <p class="is-size-1 has-text-primary stat-number">
            {{ playingCount || 0 }}
          </p>
          <p class="is-size-3 has-text-primary">PLAYING</p>
        </div>
        <div class="is-flex is-flex-direction-column">
          <p class="is-size-1 has-text-success stat-number">
            {{ simulStats.wins || 0 }}
          </p>
          <p class="is-size-3 has-text-success">WINS</p>
        </div>
        <div class="is-flex is-flex-direction-column">
          <p class="is-size-1 has-text-info stat-number">
            {{ simulStats.draws || 0 }}
          </p>
          <p class="is-size-3 has-text-info">DRAWS</p>
        </div>
        <div class="is-flex is-flex-direction-column">
          <p class="is-size-1 has-text-danger stat-number">
            {{ simulStats.loses || 0 }}
          </p>
          <p class="is-size-3 has-text-danger">LOSES</p>
        </div>
      </div>

      <div class="simul-games__requests" v-if="isJoinable">
        <SimulRequestTable :simul-id="simulId" />
      </div>

      <div class="is-flex is-justify-content-center mt-4">
        <MultiMatches :matches="matches" />
      </div>
    </div>
  </div>
</template>

<script>
import { MATCH_STATUS, SIMUL_STATUS } from "vue-chess-shared/constants";
import { firestore } from "@/services/firebase";
import { mapGetters } from "vuex";
import { SIMUL_PRIVACY } from "@/constants";
import MultiMatches from "@/components/multi/MultiMatches.vue";
import SimulRequestTable from "@/components/simuls/SimulRequestTable.vue";

const simuls = firestore.collection("simuls");
const matches = firestore.collection("matches");

export default {
  components: { MultiMatches, SimulRequestTable },

  name: "SimulGames",

  title() {
    return "Simul's games";
  },

  data() {
    return {
      isLoading: true,
      simul: null,
      matches: null,
    };
  },

  watch: {
    currentPlayer: {
      immediate: true,
      handler() {
        this.loadSimul();
      },
    },

    simul: {
      immediate: true,
      deep: true,
      handler() {
        this.loadSimul();
      },
    },
  },

  computed: {
    ...mapGetters({
      currentPlayer: "getPlayer",
    }),

    simulId() {
      return this.$route.params.simulId;
    },

    simulStats() {
      return this.simul ? this.simul.stats || {} : {};
    },

    playingCount() {
      return this.matches.filter((m) => m.status === MATCH_STATUS.LIVE).length;
    },

    simulTitle() {
      return this.simul.simulName
        ? this.simul.simulName
        : `${this.simul.owner.name}'s simul`;
    },

    isJoined() {
      if (!this.simul || !this.simul.players) return false;
      return !!this.simul.players.find(
        (p) => p.user_id === this.currentPlayer.user_id
      );
    },

    isJoinable() {
      return (
        this.simul.status === SIMUL_STATUS.CREATED ||
        this.simul.status === SIMUL_STATUS.STARTED
      );
    },
  },

  methods: {
    async loadSimul() {
      if (!this.currentPlayer || !this.simul) return;

      this.isLoading = true;

      const isOwner = this.currentPlayer.username === this.simul.owner.username;

      // can only access a private simul when user is owner or joined the simul
      if (
        this.simul.privacy === SIMUL_PRIVACY.PRIVATE &&
        !isOwner &&
        !this.isJoined
      ) {
        this.$router.replace({
          name: "simuls",
        });
        this.$buefy.toast.open({
          message: "This is an invite only simul",
          type: "is-warning",
        });
        return;
      }

      if (this.simul.status === SIMUL_STATUS.CREATED) {
        this.$router.replace({
          name: "simul",
          params: { simulId: this.simulId },
        });
        return;
      }

      if (this.loaded) {
        this.isLoading = false;
        return;
      }

      this.loaded = true;
      await this.$bind("matches", matches.where("simulId", "==", this.simulId));

      this.isLoading = false;
    },
  },

  created() {
    this.$bind("simul", simuls.doc(this.simulId));
  },
};
</script>

<style scoped>
.stat-number {
  line-height: 1;
}
.simul-games__requests {
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 99;
}
</style>
